import initializeI18next from './initialize-i18next';

export default {
  initializeI18next,
};
